import { isEmptyArray, isNotNullish } from '@local/utils'

import { MarkerType } from '@web/components/Map/Map.constants'
import { 숭례문_좌표 } from '@web/components/Map/New/constant'
import { createMarkerIcon } from '@web/components/Map/New/marker.unit'
import { CustomMarkerOption } from '@web/components/Map/New/types'
import { DailyBriefingSection_TodayBookingsFragment } from '@web/federation/gql/graphql'
import { DailyBriefingPlacePrimitive } from '@web/pages/v5/home/DailyBriefingSection/DailyBriefingMap'
import { BookingPrimitive } from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/DailyBriefingSection.type'

export const convertBookingPlaceInfoToPrimitive = (
  booking?: DailyBriefingSection_TodayBookingsFragment,
): DailyBriefingPlacePrimitive | null => {
  if (!booking) return null
  return booking?.placeSummary && booking.placeSummary.id && !booking.placeSummary.notExist
    ? {
        id: booking.placeSummary.id as string,
        name: booking.placeSummary.name as string,
        coordinate: {
          latitude: Number(booking.placeSummary.coordinate?.latitude),
          longitude: Number(booking.placeSummary.coordinate?.longitude),
        },
        images: booking.placeSummary.images as string[],
        category: { categoryCodeList: booking.placeSummary.category?.categoryCodeList as string[] },
        phone: booking.placeSummary.phone as string,
      }
    : {
        name: booking?.businessName,
        coordinate: {
          latitude: Number(booking.addressJson?.posLat),
          longitude: Number(booking.addressJson?.posLong),
        },
        images: [],
        category: { categoryCodeList: [] },
        phone: '',
      }
}

export const convertBookingToPrimitive = (booking: DailyBriefingSection_TodayBookingsFragment): BookingPrimitive => {
  return {
    businessName: booking.businessName,
    id: booking.id,
    formattedBookingDateText: booking.formattedBookingDateText,
    isCompleted: booking.isCompleted,
    visitId: booking.visitId,
    placeSummary: {
      phone: booking.placeSummary?.phone ?? '',
      isBookmarked: booking.placeSummary?.isBookmarked ?? false,
      id: booking.placeSummary?.id ?? '',
      name: booking.placeSummary?.name ?? '',
      notExist: booking.placeSummary?.notExist ?? false,
      address: {
        rcode: booking.placeSummary?.address?.rcode ?? '',
      },
      coordinate: {
        latitude: booking.placeSummary?.coordinate?.latitude ?? 0,
        longitude: booking.placeSummary?.coordinate?.longitude ?? 0,
      },
      images: booking.placeSummary?.images?.filter((img): img is string => img !== null) ?? [],
      category: {
        categoryCodeList:
          booking.placeSummary?.category?.categoryCodeList?.filter((code): code is string => code !== null) ?? [],
      },
      directionLandingUrl: {
        car: {
          appScheme: booking.placeSummary?.directionLandingUrl?.car?.appScheme,
          webUrl: booking.placeSummary?.directionLandingUrl?.car?.webUrl,
        },
        publicTransit: {
          appScheme: booking.placeSummary?.directionLandingUrl?.publicTransit?.appScheme,
          webUrl: booking.placeSummary?.directionLandingUrl?.publicTransit?.webUrl,
        },
      },
    },
  }
}

export const convertPlaceToMarkerOptions = (place: DailyBriefingPlacePrimitive): CustomMarkerOption[] => {
  const { latitude, longitude } = place.coordinate || { latitude: 숭례문_좌표.x, longitude: 숭례문_좌표.y }
  const position: naver.maps.LatLngObjectLiteral = { lat: latitude, lng: longitude }

  const imageUrl = place.images?.[0]

  const markerOption = {
    id: place.id,
    position,
    icon: createMarkerIcon({
      type: imageUrl ? MarkerType.THUMBNAIL : MarkerType.CATEGORY,
      thumbnailUrl: imageUrl,
      name: place.name || undefined,
      selected: false,
      categoryList: place.category?.categoryCodeList?.filter(isNotNullish) || [],
    }),
  } as CustomMarkerOption

  return [markerOption]
}

export const getFirstFocusBooking = (todayBookings: DailyBriefingSection_TodayBookingsFragment[]) => {
  if (isEmptyArray(todayBookings)) return null
  return todayBookings.find(booking => !booking.isCompleted) || todayBookings[todayBookings.length - 1]
}
